import Barras from './Barras';
export default Barras;